import { UnitParentComponent } from './unit-parent/unit-parent.component';
import { CustomMaterialModule } from './../../core/material.module';
import { UnitLogoComponent } from './unit-logo/unit-logo.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared-module/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { UnitInfoComponent } from './unit-info/unit-info.component';
import { UnitTreeComponent } from './unit-tree/unit-tree.component';
import { MirrorParentToggleComponent } from './mirror-parent-toggle/mirror-parent-toggle.component';
import { UnitDescriptionComponent } from './unit-description/unit-description.component';
import { UnitSettingsComponent } from './unit-settings/unit-settings.component';
import { UnitTopBarComponent } from './top-bar/top-bar.component';
import { UnitUserComponent } from './unit-user/unit-user.component';
import { QuillModule } from 'ngx-quill';
import { CareerPageComponent } from './career-page/career-page.component';
import { MjCareerPageSendContainerComponent } from './mj-career-page-send-container/mj-career-page-send-container.component';
import { JobListingModule } from '../../job-listing-module/job-listing.module';
import { MatSelectModule } from '@angular/material/select';
import { NgxUploaderModule } from 'ngx-uploader';
import { ImageCropperModule } from 'ngx-image-cropper';
import { UnitUserEditComponent } from './unit-user-edit/unit-user-edit.component';
import { MjCareerPageListingComponent } from './career-page-listing/mj-career-page-listing.component';

export const COMPONENTS = [
  UnitInfoComponent,
  UnitTreeComponent,
  UnitLogoComponent,
  MirrorParentToggleComponent,
  UnitDescriptionComponent,
  UnitSettingsComponent,
  UnitTopBarComponent,
  UnitUserComponent,
  UnitUserEditComponent,

  // legacy
  CareerPageComponent,
  MjCareerPageListingComponent,
  MjCareerPageSendContainerComponent,
  // SettingsProfileComponent,
  UnitParentComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    SharedModule,
    TranslateModule,
    MatSelectModule,
    CustomMaterialModule,
    QuillModule,
    JobListingModule,
    NgxUploaderModule,
    ImageCropperModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [],
  entryComponents: [UnitUserEditComponent],
})
export class ComponentsModule {}
